












import { computed, defineComponent } from '@nuxtjs/composition-api';
import VaimoButton from 'atoms/VaimoButton.vue';

import { ButtonVariantEnum } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'ButtonSoldOut',
  components: {
    VaimoButton
  },
  props: {
    price: {
      type: String,
      required: false,
      default: null
    }
  },
  setup(props) {
    // Determine button variant based on presence of price prop
    const buttonVariant = computed<string>(() => {
      return props.price
        ? ButtonVariantEnum.PrimaryQuickBuyWhite
        : ButtonVariantEnum.ButtonWithDotsWhite;
    });

    return {
      buttonVariant
    };
  }
});
